import type { LogoCarouselItem } from '../components/LogoCarousel/LogoSlide/LogoSlide';

export const backedLogoConfig: LogoCarouselItem[] = [
  {
    id: 'yZiLabs',
    title: 'YZiLabs',
    defaultLogoUrl: '/magicsquare/landing/backedLogo/YZiLabs.png',
    hoverLogoUrl: '/magicsquare/landing/backedLogo/YZiLabsHover.png',
    width: 167,
  },
  {
    id: 'cryptoCapital',
    title: 'Crypto Capital',
    defaultLogoUrl: '/magicsquare/landing/backedLogo/CryptoCapital.png',
    hoverLogoUrl: '/magicsquare/landing/backedLogo/CryptoCapitalHover.png',
    width: 346,
  },
  {
    id: 'kucoinLabs',
    title: 'Kucoin Labs',
    defaultLogoUrl: '/magicsquare/landing/backedLogo/KucoinLabs.png',
    hoverLogoUrl: '/magicsquare/landing/backedLogo/KucoinLabsHover.png',
    width: 147,
  },
  {
    id: 'gateioLabs',
    title: 'Gate.io Labs',
    defaultLogoUrl: '/magicsquare/landing/backedLogo/GateioLabs.png',
    hoverLogoUrl: '/magicsquare/landing/backedLogo/GateioLabsHover.png',
    width: 103,
  },
  {
    id: 'blocore',
    title: 'Blocore',
    defaultLogoUrl: '/magicsquare/landing/backedLogo/Blocore.png',
    hoverLogoUrl: '/magicsquare/landing/backedLogo/BlocoreHover.png',
    width: 169,
  },
  {
    id: 'republicCapital',
    title: 'Republic Capital',
    defaultLogoUrl: '/magicsquare/landing/backedLogo/RepublicCapital.png',
    hoverLogoUrl: '/magicsquare/landing/backedLogo/RepublicCapitalHover.png',
    width: 64,
  },
  {
    id: 'hTXVenture',
    title: 'HTX Venture',
    defaultLogoUrl: '/magicsquare/landing/backedLogo/HTXVenture.png',
    hoverLogoUrl: '/magicsquare/landing/backedLogo/HTXVentureHover.png',
    width: 244,
  },
  {
    id: 'gSR',
    title: 'GSR',
    defaultLogoUrl: '/magicsquare/landing/backedLogo/GSR.png',
    hoverLogoUrl: '/magicsquare/landing/backedLogo/GSRHover.png',
    width: 123,
  },
  {
    id: 'taisu',
    title: 'Taisu',
    defaultLogoUrl: '/magicsquare/landing/backedLogo/Taisu.png',
    hoverLogoUrl: '/magicsquare/landing/backedLogo/TaisuHover.png',
    width: 164,
  },
];
